import { useNav } from "hooks/useNav";
import { DISPATCHER, DRIVER, MANAGER, SUPERADMIN, SUPERVISOR } from "constants/constants";
import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";
import DateRangeOutlinedIcon from "@mui/icons-material/DateRangeOutlined";



import DashboardIcon from "@mui/icons-material/DashboardOutlined";
import TimelineIcon from "@mui/icons-material/Timeline";


import BarChartIcon from "@mui/icons-material/BarChart";
import TableChartIcon from "@mui/icons-material/TableChart";
import BadgeOutlined from '@mui/icons-material/BadgeOutlined';
import Badge from '@mui/icons-material/Badge';
import TruckOutlined from "@mui/icons-material/LocalShippingOutlined";
import Truck from "@mui/icons-material/LocalShipping";
import CallToActionIcon from "@mui/icons-material/CallToAction";
import DeveloperBoard from "@mui/icons-material/DeveloperBoard";
import Assessment from "@mui/icons-material/Assessment";
import Gamepad from "@mui/icons-material/Gamepad";
import TrendingUp from "@mui/icons-material/TrendingUp";
import Money from "@mui/icons-material/AttachMoney";
import HomeIcon from "@mui/icons-material/Home";

const useNavMenu = () => {
  const {
    viewDashboard,
    viewImport,
    viewReports,
    viewScorecard,
    viewCheck,
    viewAct,
    viewAmznScoreboard,
    viewPerfomance,
    viewFalcon,
    viewDas,
    viewFleets,
    viewSchedule,
    // viewPrimeSchedule,
    viewTracker,
    viewPayroll,
    viewFleetReports,
    viewDaHome,
    viewDaFeedback,
  } = useNav();

  return [
    {
      id: "dashboard",
      Icon: DashboardIcon,
      name: "Dashboard",
      link: () => viewDashboard(),
      permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
      pathnames: ["/dashboard"],
      subList: [],
    },
    {
      id: "falcon",
      Icon: TimelineIcon,
      name: "Falcon",
      link: () => viewFalcon(),
      permissionKey: [SUPERADMIN, SUPERVISOR, MANAGER],
      pathnames: ["/falcon"],
      subList: [],
    },
    {
      id: "operations",
      Icon: Gamepad,
      name: "Operations",
      link: () => null,
      permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
      pathnames: ["/das-reports"],
      subList: [
        {
          id: "shift-tracker",
          Icon: DateRangeOutlinedIcon,
          name: "Shift tracker",
          link: viewReports,
          permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
          path: "/das-reports",
        },
        {
          id: "schedule",
          Icon: DashboardIcon,
          name: "Schedule",
          link: () => viewSchedule(),
          permissionKey: [DISPATCHER, SUPERVISOR, SUPERADMIN, MANAGER],
          path: "/schedule",
        },
        // {
        //   id: "prime-schedule",
        //   Icon: DashboardIcon,
        //   name: "Prime Schedule",
        //   link: () => viewPrimeSchedule(),
        //   permissionKey: [DISPATCHER, SUPERVISOR, SUPERADMIN, MANAGER],
        //   path: "prime-schedule",
        // },
        {
          id: "tracker",
          Icon: TrendingUp,
          name: "Tracker",
          link: () => viewTracker(),
          permissionKey: [SUPERVISOR, SUPERADMIN, MANAGER],
          path: "/tracker",
        },
      ],
    },
    {
      id: "amzn-reports-main",
      Icon: DeveloperBoard,
      name: "AMZL reports",
      link: () => null,
      permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
      pathnames: ["/check", "/act", "/amzn-scoreboard", "/performance"],
      subList: [
        {
          id: "perfomance",
          Icon: BarChartIcon,
          name: "Performance",
          link: viewPerfomance,
          permissionKey: [MANAGER, SUPERADMIN, SUPERVISOR],
          path: "/performance",
        },
        {
          id: "scoreboard",
          Icon: Assessment,
          name: "Scoreboard",
          link: viewAmznScoreboard,
          permissionKey: [MANAGER, SUPERADMIN, SUPERVISOR],
          path: "/amzn-scoreboard",
        },
        {
          id: "check-amzn",
          Icon: TableChartIcon,
          name: "Check (AMZL)",
          link: viewCheck,
          permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
          path: "/check",
        },
        {
          id: "act-amzn",
          Icon: CallToActionIcon,
          name: "Act (AMZL)",
          link: viewAct,
          permissionKey: [DISPATCHER, MANAGER, SUPERADMIN, SUPERVISOR],
          path: "/act",
        },
      ],
    },
    // {
    //   id: "graphs",
    //   Icon: BarChartIcon,
    //   name: "Graphs",
    //   link: viewGraphs,
    //   permissionKey: [SUPERADMIN],
    //   pathnames: ["/graphs"],
    //   subList: [],
    // },
    {
      id: "pulse",
      Icon: BarChartIcon,
      name: "Pulse",
      link: viewScorecard,
      permissionKey: [MANAGER, SUPERADMIN, SUPERVISOR],
      pathnames: ["/scorecard"],
      subList: [],
    },
    {
      id: "da-home",
      Icon: HomeIcon,
      name: "Home",
      link: viewDaHome,
      permissionKey: [DRIVER],
      pathnames: ["/da-home"],
      subList: [],
    },
    {
      id: "da-action",
      Icon: DashboardIcon,
      name: "Action",
      link: viewDaFeedback,
      permissionKey: [DRIVER],
      pathnames: ["/da-action"],
      subList: [],
    },
    {
      id: "human-resources",
      Icon: BadgeOutlined,
      name: "Human Resources",
      link: () => null,
      permissionKey: [SUPERVISOR, DISPATCHER, SUPERADMIN, MANAGER],
      pathnames: ["/da-status"],
      subList: [
        {
          id: "da-setup",
          Icon: Badge,
          name: "DA status",
          link: viewDas,
          permissionKey: [SUPERVISOR, DISPATCHER, MANAGER, SUPERADMIN],
          path: "/da-status",
        },
        {
          id: "payroll",
          Icon: Money,
          name: "Payroll",
          link: viewPayroll,
          permissionKey: [SUPERADMIN],
          path: "/payroll",
        },
      ],
    },
    {
      id: "fleet",
      Icon: TruckOutlined,
      name: "Fleet",
      link: () => null,
      permissionKey: [SUPERVISOR, DISPATCHER, SUPERADMIN, MANAGER],
      pathnames: ["/fleet-status"],
      subList: [
        {
          id: "fleet-setup",
          Icon: Truck,
          name: "Fleet status",
          link: viewFleets,
          permissionKey: [SUPERVISOR, DISPATCHER, MANAGER, SUPERADMIN],
          path: "/fleet-status",
        },
        {
          id: "fleet-reports",
          Icon: DateRangeOutlinedIcon,
          name: "Fleet Reports",
          link: () => viewFleetReports(),
          permissionKey: [SUPERADMIN],
          path: "/fleet-reports",
        },
      ],
    },
    {
      id: "import",
      Icon: PublishOutlinedIcon,
      name: "Import",
      link: viewImport,
      permissionKey: [SUPERVISOR, MANAGER, SUPERADMIN],
      pathnames: ["/import"],
      subList: [],
    },
  ];
};

export default useNavMenu;
